/*
 WycofywanieDanych

 Tresc polityki prywatnosci Wycofywanie danych i prośby o usunięcie dla wszystkich aplikacji 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

class WycofywanieDanych extends React.Component<any, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Wycofywanie danych i prośby o usunięcie</b></Typography>
                <Typography variant='body2'>
                    Usunięcie danych lokalnie zbieranych przez aplikację może być wykonane przez jej deinstalację oraz usunięcie katalogu log/nazwaAplikacji z pamięci wewnętrznej urządzenia, na którym została zainstalowana aplikacja. Jeśli chcesz żeby Twoje dane nie były przetwarzane ani przechowywane przez administratora danych prosimy o kontakt w celu ich usunięcia z serwera i skrzynek mailowych za pośrednictwem korespondencji elektronicznej na adres: vsc.and.apk@gmail.com.
                </Typography>
            </React.Fragment>
        );
    }
}

export default WycofywanieDanych;
